import { Module, VuexModule, Action } from 'vuex-module-decorators';
import api from '@/api/setting';

@Module({ namespaced: true })
export default class extends VuexModule {
  @Action
  async getList(params: any) {
    return api.getList(params);
  }

  @Action
  async save(params: any) {
    return api.save(params);
  }

  @Action
  async add(params: any) {
    return api.add(params);
  }

  @Action
  async edit(params: any) {
    return api.edit(params);
  }

  @Action
  async delete(params: any) {
    return api.delete(params);
  }

  @Action
  async detail(params: any) {
    return api.detail(params);
  }
}
